<template>
    <div>
        <div class="midcontent">
            <img class="bgimg" src="../../assets/images/home/newhomebg.png"/>
            <div style="position: absolute; top: 0; right: 0; z-index: 155">
                <img src="../../assets/images/home/bg_top_round.png" width="70%"/>
            </div>
            <div class="contentdiv">
                <div class="leftbox">
                    <div class="leftrow0">
                        <img src="../../assets/images/home/logov1.png"/>
                    </div>
                    <div class="leftrow1">「 专业税法检索 · 智能实时管家 」</div>
                    <div class="leftrow2">
                        我们无法创造时间，但我们可以为您节约工作时间
                    </div>
                    <div class="leftrow3">
                        <Button
                                class="button22"
                                @click="gotoIndex"
                                type="warning"
                                size="large"
                        >免费体验
                        </Button
                        >
                    </div>
                    <div class="leftrow4">
                        <img src="../../assets/images/home/qrcode.png"/>
                    </div>
                    <div class="leftrow5">
                        （移动端）
                    </div>
                </div>
                <div class="rightimgbox">
                    <img src="../../assets/images/home/computer.png" height="100%"/>
                </div>
            </div>
            <div class="sider">
                <div class="row1">
                    <img src="../../assets/images/home/bg_round.png"/>
                </div>
                <div class="row2">
                    <img src="../../assets/images/home/bg_rhombus3.png"/>
                </div>
                <div class="row3">
                    <img src="../../assets/images/home/bg_rhombus2.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        created() {
            console.log("first vue created==>")
        },
        methods: {
            gotoIndex() {
                this.$router.push('localsearch')
            },
        },
        data() {
            return {
                showHome: false,
                modalStateMent: false,
                carouselValue: 0,
                value: 0
            }
        },
    }
</script>
<style scoped>

    .sider {
        position: absolute;
        right: 30px;
        display: flex;
        flex-direction: column;
        z-index: 999;
        top: 0px;
        bottom: 0px;
    }

    .row1 {
        flex: 2;
        justify-content: center;
        align-items: flex-start;
        display: flex;
    }

    .row2 {
        flex: 2;
        justify-content: left;
        align-items: center;
        display: flex;
    }

    .row3 {
        flex: 2;
        justify-content: center;
        align-items: flex-end;
        display: flex;
    }


    .midcontent {
        display: flex;
        flex: 8;
        justify-content: center;
        position: relative;
        overflow-y: hidden;
        min-width: 1250px;
    }

    .contentdiv {
        flex: 6;
        position: absolute;
        top: 15%;
        z-index: 99;
        width: 80%;
        display: flex;
        flex-direction: row;
        padding: 0 50px 0 30px;
    }

    .rightimgbox {
        flex: 4;
        display: flex;
        justify-content: center;
    }

    .leftbox {
        flex: 3;
        display: flex;
        flex-direction: column;
    }

    .leftrow0 {
        flex: 1;
    }

    .leftrow1 {
        flex: 1;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: white;
    }

    .leftrow2 {
        flex: 1;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        color: white;
    }

    .leftrow3 {
        flex: 0.8;
    }

    .button22 {
        width: 200px;
        height: 48px;
        background: linear-gradient(90deg, #efa73e 0%, #ec6d30 100%);
        border-radius: 8px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
    }

    .leftrow4 {
        flex: 1;
        
    }
    .leftrow5 {
        flex: 1;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        padding-left: 10px;
        
    }

    .bgimg {
        width: 100%;
        height: calc(100vh - 128px); /* 减去导航栏高度 */;
        min-height: 600px; /* 保证最小高度 */
        object-fit: cover;
        object-position: center;
        z-index: 5;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
        .bgimg {
            height: 400px; /* 移动端高度适当减小 */
        }
    }


</style>
